import { SELECIONAR_AGRUPADO_DISPONIBILIDADE_VEICULO } from '../types'

export default function selecionarAgrupadoDisponibilidadeVeiculo (agrupadodisponibilidadesVeiculo) {
  return {
    type: SELECIONAR_AGRUPADO_DISPONIBILIDADE_VEICULO,
    payload: agrupadodisponibilidadesVeiculo
  }
}
